import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { EstudoRenovacaoComponent } from './estudo-renovacao.component';
import { EstudoRenovacaoRoutingModule } from './estudo-renovacao.routes';
import { EstudoRenovacaoService } from './estudo-renovacao.service';

/** AngularMaterial **/
import { MatSelectModule, MatButtonModule, MatIconModule, MatInputModule, MatRadioModule,
  MatProgressBarModule, MatSnackBarModule, MatTabsModule, MatCheckboxModule, MatTableModule,
  MatPaginatorModule, MatSortModule, MatCardModule, MatToolbarModule, MatDialogModule } from '@angular/material';
import { PagerComponent} from '../paginator/pager.component';
import { QuestionarioDinamicoModule } from 'unb-questionario-componente';
import { EstudoRenovacaoListComponent } from './estudo-renovacao-list.component';
import { ApplicationPipesModule } from '../util/application.pipes.modules';
import { EstudoDialogModule } from '../estudo-dialog/estudo-dialog.module';
import { EstudoRenovacaoButtonComponent } from './estudo-renovacao-button.component';
import { EstudoRenovacaoDialogComponent } from './estudo-renovacao-dialog.component';
import { GrupoFamiliarModule } from '../grupo-familiar/grupo-familiar.module';
import { PontuacaoModule } from '../pontuacao/pontuacao.module';
import { PontuacaoDialogComponent } from '../pontuacao/pontuacao-dialog.component';
import { EstudoRenovacaoListFiltroComponent } from './estudo-renovacao-list-filtro.component';

@NgModule({
    declarations: [
      EstudoRenovacaoComponent,
      EstudoRenovacaoListComponent,
      EstudoRenovacaoDialogComponent,
      EstudoRenovacaoButtonComponent,
      EstudoRenovacaoListFiltroComponent

    ],
    exports: [
      EstudoRenovacaoComponent,
      EstudoRenovacaoListComponent,
      EstudoRenovacaoDialogComponent,
      EstudoRenovacaoButtonComponent,
      EstudoRenovacaoListFiltroComponent
    ],
    imports: [
      FormsModule, CommonModule, 
      QuestionarioDinamicoModule, GrupoFamiliarModule, ApplicationPipesModule, EstudoDialogModule,
      MatSelectModule, MatButtonModule, MatIconModule, MatInputModule, MatProgressBarModule,
      MatSnackBarModule, MatRadioModule, MatTabsModule, MatSortModule, MatCheckboxModule, MatTableModule,
      MatPaginatorModule, MatCardModule, MatToolbarModule, EstudoRenovacaoRoutingModule, MatDialogModule 
    ],
    providers: [
      EstudoRenovacaoService, PagerComponent
    ],
    entryComponents: [ PontuacaoDialogComponent ]
})
export class EstudoRenovacaoModule {
  
}
